import { useIsTruncated } from "#shared/hooks/useIsTruncated";
import { RichTooltip } from "#shared/view/designSystem/RichTooltip";

type EllipsisTooltipProps = {
  content: React.ReactNode;
};

const ellipsisStyle: React.CSSProperties = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const EllipsisTooltip = ({ content }: EllipsisTooltipProps) => {
  const { ref, isTruncated } = useIsTruncated<HTMLDivElement>();

  if (!isTruncated) {
    return (
      <div ref={ref} style={ellipsisStyle}>
        {content}
      </div>
    );
  }

  return (
    <RichTooltip
      position="bottom"
      selectable
      target={
        <div ref={ref} style={ellipsisStyle}>
          {content}
        </div>
      }
    >
      {content}
    </RichTooltip>
  );
};
